// Pure helper for the POST /courses billing address contribution. Kept out of
// the RepairConfirmation closure so the "no selection ⇒ no billing_address_id
// (zero regression)" invariant is unit-testable in isolation. Mirrors the
// buildDevisSelectionPayload pattern (Object.assign into courseParams).
export const buildBillingAddressPayload = (billingAddressId) => {
  if (!billingAddressId) return {};
  return { billing_address_id: billingAddressId };
};

export default buildBillingAddressPayload;
